import PropTypes from "prop-types";
import React, { Fragment } from "react";
import ShopTopAction from "../../components/product/ShopTopAction";

const ShopTopbar = ({
  currentPage,
  getLayout,
  getFilterSortParams,
  onPageLimitChange,
  pageLimit,
  productCount,
  sortedProductCount,
  sortOrder,
  onSortChange,
}) => {
  return (
    <Fragment>
      {/* shop top action */}
      <ShopTopAction
        currentPage={currentPage}
        getLayout={getLayout}
        getFilterSortParams={getFilterSortParams}
        onPageLimitChange={onPageLimitChange}
        onSortChange={onSortChange}
        pageLimit={pageLimit}
        productCount={productCount}
        sortedProductCount={sortedProductCount}
        sortOrder={sortOrder}
      />
    </Fragment>
  );
};

ShopTopbar.propTypes = {
  currentPage: PropTypes.number,
  getFilterSortParams: PropTypes.func,
  getLayout: PropTypes.func,
  onPageLimitChange: PropTypes.func,
  onSortChange: PropTypes.func,
  pageLimit: PropTypes.number,
  productCount: PropTypes.number,
  sortedProductCount: PropTypes.number,
  sortOrder: PropTypes.string,
};

export default ShopTopbar;
